import { render, staticRenderFns } from "./WebsiteSeo.vue?vue&type=template&id=2b1c8e74&scoped=true&"
import script from "./WebsiteSeo.vue?vue&type=script&lang=js&"
export * from "./WebsiteSeo.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteSeo.vue?vue&type=style&index=0&id=2b1c8e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c8e74",
  null
  
)

export default component.exports